<template>
    <div class="px-6 work-order" :data-closed="(order && order.closed)">
    <header class="mt-6 flex justify-between border-b-4 items-center">
        <h1 class="text-4xl"><span class="pr-4">Order #{{ $route.params.number }}</span>
            <span v-if="order" class="font-bold text-lg text-gray-500 border-l pl-4">LINE {{ order.product.line }}</span>
            </h1>
        <nav>
            <button class="bg-orange-500 border text-white hover:text-gray-700 hover:bg-white px-3 py-1 rounded text-sm mr-2" @click="createLogEntry()" v-if="order && !order.closed">{{ firstproductionCount?'+ Add Log Entry':'Start Log' }}</button>
            <button class="bg-purple-500 border text-white hover:text-gray-700 hover:bg-white px-3 py-1 rounded text-sm mr-2" v-if="firstproductionCount && !order.closed" @click="markAsComplete">Close Order</button>
            <button class="bg-green-500 border text-white hover:text-gray-700 hover:bg-white px-3 py-1 rounded text-sm mr-2" v-else-if="order && order.closed" @click="exportReport">Export Report</button>
            <router-link v-if="order && !order.closed" class="bg-gray-200 border text-gray-600 hover:text-gray-700 hover:bg-white px-3 py-1 rounded text-sm" :to="{ name: 'edit-order', params: { number: order.number }}">Modify</router-link>
        </nav>
    </header>
        <section class="flex text-gray-800 mt-4 w-full border-b pb-2" v-if="order">
                        <div class="border-l pl-6 mr-6 w-1/3">
                <label class="text-teal-500 text-sm">SKU {{ order.product.sku }}</label>
                <p class="font-bold  text-xl">{{ order.product.description }} </p>
            </div>
            <div class="border-l pl-6 mr-6 w-1/3">
                <label class="text-teal-500 text-sm">Filled</label>
                <p class="font-bold  text-xl">{{ (unitsProduced / order.amount_ordered) | percent(1) }}% <small class="font-normal text-sm">({{ unitsProduced }} of {{ order.amount_ordered }})</small></p>
            </div>
            <div class="border-l pl-6 w-1/3">
                <label class="text-teal-500 text-sm">Efficiency ({{ expectedPPM }} ppm goal)</label>
                <p class="font-bold  text-xl">{{ efficiency | percent(1) }}% <small>({{ actualPPM | decimal(1) }} ppm)</small></p>
            </div>
            </section>
            <section class="flex text-gray-800 mt-2 w-full border-b pb-2" v-if="order">
            <div class="border-l pl-6 mr-6 w-1/3">
                <label class="text-teal-500 text-sm">Started {{ firstProductionTimespan?firstProductionTimespan.start:"" | date }}</label>
                <p class="font-bold  text-xl">{{ firstProductionTimespan?firstProductionTimespan.start:"" | time | dashedblank }} </p>
                <p class="text-xs text-gray-500">Expected: {{ order.expected_start_date | datetime }} </p>
            </div>
            <div class="border-l pl-6 mr-6 w-1/3">
                <label class="text-teal-500 text-sm">Status: {{ lastproductionCount?lastproductionCount.date:"" | datetime }}</label>
                <p class="font-bold  text-xl">{{ lineStateDesc | capitalize }}</p>
                <p class="text-xs text-gray-500">{{ counterKey | capitalize }} Count: {{ lastproductionCount?lastproductionCount.value:"---" }}</p>
            </div>
            <div class="border-l pl-6 w-1/3">
                <label class="text-teal-500 text-sm">Actual Run Time</label>
                <p class="font-bold  text-xl">{{ actualRuntime | timespan }}</p>
                <p class="text-xs text-gray-500">Expected: {{ expectedRuntime | timespan }} </p>
            </div>
            </section>
        <section class="flex text-gray-800 mt-2 w-full border-b pb-2" v-if="order">
            <div class="border-l pl-6 mr-6 w-1/3">
                <label class="text-teal-500 text-sm">Setup</label>
                <p class="font-bold  text-xl"><span v-if="setup.duration">{{ setup.duration | timespan }}</span><span v-else>---</span> </p>

            </div>
            <div class="border-l pl-6 mr-6 w-1/3">
                <label class="text-teal-500 text-sm">Lunch</label>
                <p class="font-bold  text-xl"><span v-if="lunch.duration">{{ lunch.duration | timespan }}</span><span v-else>---</span> </p>
            </div>
            <div class="border-l pl-6 w-1/3">
                <label class="text-teal-500 text-sm">Cleaning</label>
                <p class="font-bold  text-xl"><span v-if="cleaning.duration">{{ cleaning.duration | timespan }}</span><span v-else>---</span></p>
            </div>
        </section>

        <section class="flex text-gray-800 mt-2 w-full " v-if="order">
            <div class="border-l pl-6 mr-6 w-1/3">
                <label class="text-teal-500 text-sm">Notes <small v-if="!editNotes">(click to edit)</small><button v-if="editNotes" class="border border-teal-500 rounded text-xs px-1 ml-1 text-white bg-teal-500" @click="onSaveNotes">Save</button><button v-if="editNotes" class="border rounded text-xs px-1 ml-1 text-gray-500" @click="onCancelNotes">Cancel</button></label>

                <p class="mt-1 text-sm" v-if="!editNotes"><span v-if="order.notes" @click="onEditNotes">{{ order.notes }}</span><span v-else @click="onEditNotes">---</span> </p>
                <div v-if="editNotes">
                    <textarea class="border p-1 mt-1 w-full text-sm" v-model="notesClipboard" @blur="onSaveNotes"></textarea>
                </div>




            </div>
            <div class="border-l pl-6 mr-6 w-1/3">
                <label class="text-teal-500 text-sm">Internal Downtime (Total)</label>
                <p class="font-bold  text-xl"><span v-if="downtimeMinutes">{{ internalDowntimeMinutes | timespan }} <small>( {{ downtimeMinutes | timespan }} )</small></span><span v-else>---</span> </p>
            </div>
            <div class="border-l pl-6 w-1/3">
                <label class="text-teal-500 text-sm">Loss</label>
                <p class="font-bold  text-xl"><span v-if="lossAmount">{{ lossAmount }}</span><span v-else>---</span></p>
            </div>
        </section>


        <section class="flex p-4 bg-gray-100 border mt-8" v-if="order && countChartData">
            <div class="flex-grow">
                <chart-line :chart-data="countChartData" :options="countChartOptions" :height="200" class="mt-4 relative"></chart-line>
            </div>
            
        </section>
        
        <section class="mb-8 mt-8" v-if="firstproductionCount">
            <header class="mt-6 pb-2">
                <h1 class="text-2xl mr-2 mb-2">Logs</h1>
                <div  class="flex justify-between items-end border-b-4">

                    <div class="">
                        <button @click="setLogFilter('production')" class="tab border border-b-0 px-3 py-2 mr-2 rounded-t text-sm text-gray-700" :data-active="logFilter=='production'">Production ({{ unitsProduced }} of {{ order.amount_ordered }})</button>
                        <button @click="setLogFilter('downtime')" class="tab border border-b-0 px-3 py-2 mr-2 rounded-t text-sm text-gray-700" :data-active="logFilter=='downtime'">Downtime ({{ downtimeMinutes }} min)</button>
                        <button @click="setLogFilter('loss')" class="tab border border-b-0 px-3 py-2 rounded-t text-sm text-gray-700" :data-active="logFilter=='downtime'">Loss ({{ lossAmount }} units)</button>
                    </div>

                    <nav class="pb-2">
                        <button @click="createLogEntry" v-if="order && !order.closed" class="log-button bg-orange-500 text-white px-3 py-1 rounded text-sm" :data-mode="logFilter">+ Add <span>{{ logButtonLabel }}</span></button>
                    </nav>

                </div>



            </header>
            
            <table class="w-full text-left text-sm" v-if="logFilter=='production'">
                <thead>
                    <tr class="text-teal-500 border-b">
                        
                        <th class="py-2 px-2">Date</th>
                        <th>Details</th>
                        <th><span v-if="counterKey">{{ counterKey | capitalize }}</span> Count</th>
                        <th>Expected Count</th>
                        <th>Units Produced</th>
                        <th>Expected Units</th>
                        <th>Efficiency</th>
                        <th>Timeframe</th>
                        <th>PPM</th>
                        <th>Notes</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="striped text-gray-700 group border-b odd:bg-gray-100 hover:border-gray-500" v-for="log in productionLogs" :key="log.id" :data-error="(log.production < 0)" :data-warning="log.warning">
                        
                        <td class="py-2 pl-4 hover:underline"><a @click="editLogEntry(log)" class="edit-btn"><span class="hover:border-orange-500 hover:bg-orange-500 hover:text-white inline-block mr-2 px-2 text-xs border cursor-pointer">EDIT</span>{{ log.date | datetime }}</a></td>
                        <td>{{ logEntrySummary(log) }}</td>
                        <td>{{ (log.tag=="count")?log.value:"" }}</td>
                        <td>{{ log.expectedTotal }}</td>
                        <td>{{ log.production }}</td>
                        <td>{{ log.expected }}</td>
                        <td><span v-if="log.expected">{{ log.expected?(log.production /log.expected):0 | percent }}%</span></td>
                        <td>{{ log.minutes }} min</td>
                        <td>{{ (log.production / log.minutes) | decimal(1) }}</td>
                        <td>{{ log.note }}</td>
                    </tr>
                </tbody>
            </table>
            <table class="w-full text-left text-sm" v-if="logFilter=='downtime'">
                <thead>
                <tr class="text-teal-500 border-b">

                    <th class="py-2 px-2">Date</th>
                    <th>Machine</th>
                    <th>Reason</th>
                    <th>Duration</th>
                    <th>Solution / Fix</th>

                </tr>
                </thead>
                <tbody>
                <tr class="striped text-gray-700 group border-b odd:bg-gray-100 hover:border-gray-500" v-for="log in downtimeLogs" :key="log.id">

                    <td class="py-2 pl-4 hover:underline"><a @click="editLogEntry(log)" class="edit-btn"><span class="hover:border-orange-500 hover:bg-orange-500 hover:text-white inline-block mr-2 px-2 text-xs border cursor-pointer">EDIT</span>{{ log.date | datetime }}</a></td>
                    <td>{{ log.code }}</td>
                    <td>{{ log.detail }}</td>
                    <td>{{ log.value }}</td>
                    <td>{{ log.note }}</td>
                </tr>
                </tbody>
            </table>
            <table class="w-full text-left text-sm" v-if="logFilter=='loss'">
                <thead>
                <tr class="text-teal-500 border-b">

                    <th class="py-2 px-2">Date</th>
                    <th>Amount</th>
                    <th>Machine</th>
                    <th>Reason</th>

                </tr>
                </thead>
                <tbody>
                <tr class="striped text-gray-700 group border-b odd:bg-gray-100 hover:border-gray-500" v-for="log in lossLogs" :key="log.id">

                    <td class="py-2 pl-4 hover:underline"><a @click="editLogEntry(log)" class="edit-btn"><span class="hover:border-orange-500 hover:bg-orange-500 hover:text-white inline-block mr-2 px-2 text-xs border cursor-pointer">EDIT</span>{{ log.date | datetime }}</a></td>
                    <td>{{ log.value }}</td>
                    <td>{{ log.code }}</td>
                    <td>{{ log.note }}</td>


                </tr>
                </tbody>
            </table>
        </section>

        <modal-panel class="modal" v-if="showLogForm">
            <log-form :work-order-num="order.number" :line="order.product.line" :order="order" :related-logs="productionCounts" :record="selectedLog" :shortcut-id="logEntryShortcut" :shortcut-options="shortcutOptions" :counter-key="counterKey" :last-production-count="lastproductionCount?lastproductionCount.value:''" @close="onCloseLogForm" @update="onLogUpdate"></log-form>
        </modal-panel>
        

    </div>
  
</template>

<script>

import LogForm from "../components/LogForm.vue"
import ModalPanel from "../components/ModalPanel.vue"
import ChartLine from "../components/ChartLine.js";

import SelectDropdown from "../components/SelectDropdown";
import XLSX from "xlsx"

export default {
    name: "work-order",
    components: {
        SelectDropdown,
        LogForm,
        ModalPanel,
        ChartLine,
    },
    mounted: function(){

        

        this.loadRecords().then((order)=>{
            if(!order){
                this.$router.push({name:"orders"});
            }

            
        })

        
    },
    data: function(){
        return {
            order: null,
            logs: [],
            showLogForm: false,
            selectedLog: null,
            logEntryShortcut: null,

            countChartData: null,
            timelineChartData: null,
            logFilter:"production",
            editNotes: false,
            notesClipboard: ""
        }
    },

    methods: {

        exportReport: function(){

            var rows = [
                ["Order Number", "SKU", "Description", "Expected Start", "","Actual Start", "","Order Amount", "Amount Filled", "Run Time (minutes)", "Goal PPM", "Actual PPM", "Downtime", "Loss", "Setup Time", "Lunch Time", "Cleaning Time", "Notes"],
                [
                    this.order.number,
                    this.order.product.sku,
                    this.order.product.description,
                  this.order.expected_start_date?(new Date(this.order.expected_start_date)).mmddyyyy():"",
                  this.order.expected_start_date?(new Date(this.order.expected_start_date)).HHmm():"",

                  this.order.actual_start_date?(new Date(this.order.actual_start_date)).mmddyyyy():"",
                  this.order.actual_start_date?(new Date(this.order.actual_start_date)).HHmm():"",

                    this.order.amount_ordered,
                    this.order.amount_filled,
                    this.actualRuntime,
                    this.order.product.expected_upm,
                    this.actualPPM,
                    this.downtimeMinutes,
                    this.lossAmount,
                    this.setup.duration,
                    this.lunch.duration,
                    this.cleaning.duration,
                    this.order.notes
                ]
            ]

            var wb = XLSX.utils.book_new();
            var today = new Date();
            wb.Props = {
                Title: ("Work Order " + this.order.number),
                CreatedDate: today
            }

            var productionLogs = [[ "ID", "Date", "Time", "Line", "Work Order", "Count", "Details", "Notes"]];
            [...this.productionCounts].reverse().forEach((countLog) => {
                productionLogs.push(
                    [
                        countLog.id,
                        (new Date(countLog.date)).mmddyyyy(),
                      (new Date(countLog.date)).HHmm(),
                        this.order.line,
                        this.order.number,
                        countLog.value,
                        this.logEntrySummary(countLog),
                        countLog.note
                    ]
                )
            })

            var downtimeLogs = [[ "ID", "Date", "Time", "Line", "Work Order", "Minutes Down", "Machine", "Reason", "Solution/Fix"]];
            [...this.downtimeLogs].reverse().forEach((downtime) => {
                downtimeLogs.push(
                    [
                        downtime.id,
                        (new Date(downtime.date)).mmddyyyy(),
                      (new Date(downtime.date)).HHmm(),
                        this.order.line,
                        this.order.number,
                        downtime.value,
                        downtime.code,
                        downtime.detail,
                        downtime.note
                    ]
                )
            })

            var lossLogs = [[ "ID", "Date", "Time","Line", "Work Order", "Loss Amount", "Machine", "Reason"]];
            [...this.lossLogs].reverse().forEach((loss) => {
                lossLogs.push(
                    [
                        loss.id,
                        (new Date(loss.date)).mmddyyyy(),
                      (new Date(loss.date)).HHmm(),
                        this.order.line,
                        this.order.number,
                        loss.value,
                        loss.code,
                        loss.note
                    ]
                )
            })


            console.log(rows);
            var ws = XLSX.utils.aoa_to_sheet(rows);
            XLSX.utils.book_append_sheet(wb, ws, "Work Order");

            var logWs = XLSX.utils.aoa_to_sheet(productionLogs);
            XLSX.utils.book_append_sheet(wb, logWs, "Production Logs");

            var downtimeWs = XLSX.utils.aoa_to_sheet(downtimeLogs);
            XLSX.utils.book_append_sheet(wb, downtimeWs, "Downtime Logs");

            var lossWs = XLSX.utils.aoa_to_sheet(lossLogs);
            XLSX.utils.book_append_sheet(wb, lossWs, "Loss Logs");

            //
            XLSX.writeFile(wb, `work-order-${this.order.number}.xlsx`);
        },

        onEditNotes: function(){
            if(this.order){
                this.notesClipboard = this.order.notes;
                this.editNotes = true;
            }

        },

        onSaveNotes: function(){
            if(this.order){

                this.editNotes = false;

                if(this.order.notes != this.notesClipboard){
                    console.log("saving notes");
                    this.order.notes = this.notesClipboard;
                    this.updateOrderRecord({ notes: this.notesClipboard });
                }



            }

        },

        onCancelNotes: function(){
            if(this.order){
                this.editNotes = false;
            }

        },

        setLogFilter: function(logFilter){

            this.logFilter = logFilter;
        },

        logEntrySummary: function(log){
            if(log.code){
                if(log.type == "downtime") {
                    return "downtime: " + log.code + "(" + log.value + "min)";

                }else if(log.code == "pause"){
                    if(log.detail == "end"){
                        return "production resumed";
                    }else{
                        return "production paused"
                    }
                }else{
                    //used for setup, cleaning, and lunch
                    let duration;
                    if(log.detail == "end"){
                        let logInfo = this[log.code];
                        if(logInfo){
                            duration = logInfo.duration;
                            return log.code + " "+log.detail + " ("+duration+"min)";
                        }
                    }
                    return log.code + " "+log.detail;
                }
            }

            if(log.tag == "count"){
                return log.key + " count";
            }

            return log.tag + " " + log.key;
        },

        

        setTimelineChartData () {

            let timeline = {
                setup: 0,
                cleaning: 0,
                production: 0,
                downtime: 0
            }

            this.sortedLogs.forEach((log) => {
                if(log.tag == "downtime"){
                    if(log.code == "setup"){
                        timeline.setup += log.value;
                    } else if(log.code == "cleaning"){
                        timeline.cleaning += log.value;
                    }else {
                        timeline.downtime += log.value;
                    }
                }
            })

            timeline.production = this.actualRuntime - (timeline.setup + timeline.cleaning + timeline.downtime);


            this.timelineChartData = {
                labels: ['Setup', 'Cleaning', 'Production', 'Downtime'],
                datasets: [
                    {
                    backgroundColor: [ "#FEEBC8","#FED7E2","#B2F5EA","#F56565" ],
                    data: [timeline.setup, timeline.cleaning, timeline.production, timeline.downtime]
                    }
                ]
            }
        },


        setCountChartData () {

        let startCount = this.firstproductionCount?this.firstproductionCount.value:0;

        this.countChartData = {
            
          datasets: [
            {
              label: 'Units Produced',
              backgroundColor: '#B2F5EA',
              lineTension: 0,
              data: this.productionCounts.map((count) => {
                  return {
                      t: new Date(count.date),
                      y: (count.value - startCount)
                  }
              })
            },
              {
                  label: 'Tgt Production',
                  backgroundColor: 'rgba(230, 240, 255, 0.1)',
                  pointBackgroundColor: '#ddd',
                  lineTension: 0,
                  borderDash: [5,2],
                  borderDashOffset: 1.0,
                  data: this.getHourlyTargetProduction()
              }
          ]
        }
      },


        getHourlyTargetProduction: function(){
            var tgts = [];







            let timespans = this.timespans;

            var targetCount = 0;


            timespans.forEach((timespan, timespanIndex) => {
                if(timespanIndex == 0){
                    tgts.push({
                        x: timespan.start,
                        y: targetCount
                    });
                }

                targetCount += timespan.targetProduction;

                tgts.push({
                    x: timespan.end,
                    y: targetCount
                });
            });



            if(targetCount < this.order.amount_ordered){

                var startTime, hours, remainingAmount, remainingTime;


                if(timespans.length){
                    startTime = timespans[timespans.length - 1].end;
                    remainingAmount = this.order.amount_ordered - targetCount;
                    remainingTime = (remainingAmount/this.expectedPPM)/60;

                }else{
                    startTime = this.actualProductionStart?this.actualProductionStart:this.expectedStartDate;
                    remainingTime = this.expectedRuntime / 60;

                }

                hours = Math.floor(remainingTime);






                for (var i=0; i<=hours; i++){

                    let tgtDate = new Date(startTime.getTime() + (i * 3600000));
                    let tgtAmount = targetCount + (this.expectedPPM * ( i * 60 ));

                    tgts.push({
                        x: tgtDate,
                        y: tgtAmount
                    })
                }

                let remainder = remainingTime - hours;

                if(remainder){
                    tgts.push({
                        x: new Date(startTime.getTime() + (remainingTime * 60 * 60000)),
                        y: this.order.amount_ordered
                    })
                }
            }





            return tgts;

        },

      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },
        


        loadRecords: async function(){
            await this.$api.apiRequest("get","workorders/"+this.$route.params.number+"/").then((response) => {
                        if(response.success){
                            this.order = response.success.data;
                            
                        }
                    })
                    .catch((error)=>{
                        console.log("Uncaught Error", error);
                    })

            if(this.order){
                await this.getLogs().then((logs) => {
                    console.log("logs received", logs);
                })
            }

            return this.order;
        },

        getLogs: async function(){
            await this.$api.getRecords("productionlogs/", { work_order: this.$route.params.number, limit: 200 })
            .then((response)=>{

                console.log("logs",response);
                if(response && response.results){
                    

                    this.logs = response.results;
                    this.setCountChartData();
                    this.setTimelineChartData();

                }
            })

            return this.logs;

        },

        createLogEntry: function(shortcutId = ""){

            if(this.order.closed){
                if(!confirm("This order is marked as completed. Are you sure you want to add another log entry?")){
                    return;
                }
            }
            this.logEntryShortcut = shortcutId;
            this.showLogForm = true;
        },

        onCloseLogForm: function(){
                       
            this.showLogForm = false;
            this.selectedLog = null;
            this.logEntryShortcut = "";
            
        },

        editLogEntry: function(log){
            
            this.selectedLog = log;
            this.showLogForm = true;
        },

        onLogUpdate: function(logEntry){



            this.getLogs().then(()=>{

                var orderChanges = {}


                //check logs to see if the order record needs adjustment
                if(this.order.actual_start_date && !this.setup.start){
                    //order previously marked as started, but setup start is missing.
                    orderChanges = { ...orderChanges, actual_start_date: null }
                }else if(this.order.actual_start_date != this.setup.start.date){
                    orderChanges = { ...orderChanges, actual_start_date: this.setup.start.date }
                }

                if(this.order.amount_filled != this.unitsProduced){
                    orderChanges = { ...orderChanges, amount_filled: this.unitsProduced }
                }

                if(this.order.actual_completion_date && !this.orderCompleted){
                    orderChanges = { ...orderChanges, actual_completion_date: null }
                }else if(!this.order.actual_completion_date && this.orderCompleted){
                    orderChanges = { ...orderChanges, actual_completion_date: this.orderCompleted.date }
                }else if(this.orderCompleted && this.actualCompletionDate != this.orderCompleted.date){
                    orderChanges = { ...orderChanges, actual_completion_date: this.orderCompleted.date }
                }

                if(Object.keys(orderChanges).length > 0){
                    console.log("Order Updated...", orderChanges);
                    this.updateOrderRecord(orderChanges);
                }

            })
            .catch((error) => {
                console.log("Error after get logs...",error);
                alert("There was an error updating this order.")
            })


            
        },

        markAsComplete: function(){

            if(confirm("Marking this order as complete will prevent any further editing of this order's details or log entries. Do you wish to proceed?")){
                this.order.complete = true;
                this.updateOrderRecord({ closed: true });
            }



        },

        reopenOrder: function(){
            let orderChanges = { actual_completion_date: null };
            this.updateOrderRecord(orderChanges);
        },

        updateOrderRecord: function(changes){

            if(changes){
                    this.$api.apiRequest("patch","workorders/"+this.$route.params.number+"/",changes).then((response) => {
                        
                        if(response.error){
                             console.log("error", response.error);
                             alert(response.error.response.statusText);
                        }else{
                            this.order = { ...this.order, ...changes };
                        }
                    })
                    .catch((error) => {
                        console.log("error", error, error.response);
                        alert("There was an error updating this record.")
                    })

                }

        },

        getMinutesBetween: function(startTime, endTime){

            if(startTime && endTime){
                let firstDate = new Date(startTime);
                let lastDate = new Date(endTime);

                return (lastDate.getTime() - firstDate.getTime()) / 60000;
            }

        }
    },

    computed: {

        lineState: function(){
            if(this.lastproductionCount){
                if(this.lastproductionCount.code){
                    if(this.lastproductionCount.detail != "end"){
                        return this.lastproductionCount.code;
                    }else{
                        if(this.lastproductionCount.code == "cleaning"){
                            return "cleaned"
                        }
                    }


                }


            }


            return "production"

        },

        lineStateDesc: function(){

            if(this.order && this.order.closed){

                return "Order Closed";
            }

            if(!this.lastproductionCount){

                return "Not Started";
            }

            if(this.lineState == "pause"){
                return "Production Paused"
            }

            if(this.lineState == "cleaned"){
                return "Order Completed"
            }

            if(this.lineState=='production'){
                return "In Production"
            }

            return this.lineState;


        },

        productionPaused: function(){
            if(this.lineState != "production"){
                return true;
            }
            return false;
        },

        logStarted: function(){
            return this.lastproductionCount?true: false;
        },


        orderFilled: function(){
            if(this.unitsProduced){
                return (this.unitsProduced >= this.order.amount_ordered);
            }

            return false;
        },

        lastTimespan: function(){
            if(this.timespans.length){
                return this.timespans[this.timespans.length - 1];
            }
        },

        orderCompleted: function(){
            //if order is filled and line is cleaned, return cleaning end time.
            if(this.orderFilled){
                if(this.lastTimespan){
                    if(this.lastTimespan.type == "cleaning"){
                        return this.lastTimespan.logs[this.lastTimespan.logs.length - 1];
                    }
                }
            }
        },

        counterKey: function(){
            if(this.order.product){
                return this.order.product.counter
            }
        },

        expectedPPM: function(){
            if(this.order.product){
                return this.order.product.expected_upm;
            }

            return 0;
        },

        maxPPM: function(){
            if(this.order.product){
                return this.order.product.max_upm;
            }

            return 0;
        },

        targetUnitsProduced: function(){
            return this.expectedPPM * this.actualRuntime;
        },

        expectedStartDate: function(){

            if(this.order.expected_start_date){
                return new Date(this.order.expected_start_date);
            }
            
        },

        expectedRuntime: function(){
            //returns minutes
            if(this.expectedPPM && this.order.amount_ordered){
                return Math.ceil(this.order.amount_ordered / this.expectedPPM)
            }

            return 0;
        },

        expectedCompletionDate: function(){

            if(this.actualStartDate && this.expectedRuntime){
                return new Date(this.actualStartDate.getTime() + this.expectedRuntime * 60000);
            }else if(this.expectedStartDate && this.expectedRuntime){
                return new Date(this.expectedStartDate.getTime() + this.expectedRuntime * 60000);
            }

        },

        actualStartDate: function(){
            if(this.order && this.order.actual_start_date){
                return new Date(this.order.actual_start_date);
            }
        },

        actualProductionStart: function(){
            if(this.setup && this.setup.timespans.length){
                return new Date(this.setup.timespans[0].end);
            }
        },

        actualCompletionDate: function(){ 
            if(this.order && this.order.actual_completion_date){
                return new Date(this.order.actual_completion_date);
            }
        },



        actualProductionTime: function(){
            //returns minutes
            if(this.firstproductionCount && this.lastproductionCount){
                return this.getMinutesBetween(this.firstproductionCount.date, this.lastproductionCount.date);
            }

            return 0;
        },

        actualRuntime: function(){
            //returns minutes
            if(this.actualProductionTime){
                let minutes = 0;
                this.timespans.forEach((timespan) => {
                    if(timespan.type == "production"){
                        minutes += timespan.duration;
                    }
                })

                return minutes;
            }

            return 0;
        },



        unitsProduced: function(){
            if(this.lastproductionCount){
                return (this.lastproductionCount.value - this.firstproductionCount.value);
            }

            return 0;
        },

        actualPPM: function(){
            if(this.unitsProduced){
                return (this.unitsProduced / this.actualRuntime);
            }

            return 0;
        },



        

        efficiency: function(){
            if(this.unitsProduced){
                return this.actualPPM / this.expectedPPM;
            }

            return 0;
        },

        

        sortedLogs: function(){

            if(this.logs){
                return [...this.logs].sort((a,b) => {
                    if(a.date < b.date){
                        return 1;
                    }else if(a.date > b.date){
                        return -1;
                    }else{
                        return 0
                    }
                })
            }

            return [];
        },


        setup: function(){

            var info = {
                start: null,
                timespans: [],
                duration: 0
            }

            let setupStarts = this.sortedLogs.filter((log) => {
                return ((log.code == "setup") && (log.detail == "start"));
            });

            if(setupStarts.length){
                info.start = setupStarts.pop();
            }

            this.timespans.forEach((timespan) => {
                if(timespan.type == "setup"){
                    info.timespans.push(timespan);
                    info.duration += timespan.duration;
                }
            })



            // this.sortedLogs.forEach((log) => {
            //     if(log.code == "setup"){
            //         if(log.detail == "start"){
            //             if(!info.start){
            //                 info.start = log;
            //             }
            //         }
            //
            //         if(log.detail == "end"){
            //
            //             info.end = log;
            //
            //         }
            //     }
            // });
            //
            // if(info.start && info.end){
            //     info.duration = this.getMinutesBetween(info.start.date, info.end.date);
            // }


            return info;

        },

        cleaning: function(){

            var info = {
                timespans: [],
                duration: 0
            }

            // this.sortedLogs.forEach((log) => {
            //     if(log.code == "cleaning"){
            //         if(log.detail == "start"){
            //             if(!info.start){
            //                 info.start = log;
            //             }
            //         }
            //
            //         if(log.detail == "end"){
            //
            //             info.end = log;
            //
            //         }
            //     }
            // });
            //
            // if(info.start && info.end){
            //     info.duration = this.getMinutesBetween(info.start.date, info.end.date);
            // }

            this.timespans.forEach((timespan) => {
                if(timespan.type == "cleaning"){
                    info.timespans.push(timespan);
                    info.duration += timespan.duration;
                }
            })



            return info;

        },

        lunch: function(){

            var info = {
                timespans: [],
                duration: 0
            }

            // this.sortedLogs.forEach((log) => {
            //     if(log.code == "lunch"){
            //         if(log.detail == "start"){
            //             if(!info.start){
            //                 info.start = log;
            //             }
            //         }
            //
            //         if(log.detail == "end"){
            //
            //             info.end = log;
            //
            //         }
            //     }
            // });
            //
            // if(info.start && info.end){
            //     info.duration = this.getMinutesBetween(info.start.date, info.end.date);
            // }

            this.timespans.forEach((timespan) => {
                if(timespan.type == "lunch"){
                    info.timespans.push(timespan);
                    info.duration += timespan.duration;
                }
            })


            return info;

        },


        productionCounts: function(){
            if(!this.sortedLogs) { return [] }
            let counts = this.sortedLogs.filter((entry) => {
                return (entry.tag == "count");
            })

            var lastEntry;
            var total = 0;

            return counts.reverse().map((count) => {
                if(lastEntry){
                    let countValue = parseInt(count.value);
                    let date = new Date(count.date);
                    let lastDate = new Date(lastEntry.date);
                    count.production = countValue - total;
                    total = countValue;

                    count.minutes = (date.getTime() - lastDate.getTime()) / 60000;


                    if(count.detail == "end"){
                        count.expected = 0;
                        count.expectedTotal = lastEntry.value;
                    }else{
                        count.expected = parseInt(this.expectedPPM * count.minutes);
                        count.expectedTotal = lastEntry.value + count.expected;
                    }

                    if(count.detail != "start"){
                        count.nextHourCountTarget = parseInt(this.expectedPPM * 60) + total;
                    }else{
                        count.nextHourCountTarget = total;
                    }

                }else{
                    count.production = 0;
                    count.expected = 0;
                    count.minutes = 0;
                    count.expectedTotal = count.value;

                    if(count.detail != "start"){
                        count.nextHourCountTarget = parseInt(this.expectedPPM * 60);
                    }else{
                        count.nextHourCountTarget = count.value;
                    }
                    total = count.value;


                }

                count.variance = count.production - count.expected;
                if(count.expected){
                    count.efficiency = (count.production / count.expected);
                }else{
                    count.efficiency = NaN;
                }

                if(count.efficiency < 0.5){
                    count.warning = 3;
                }else if (count.efficiency < 0.8) {
                    count.warning = 2;
                }else if (count.efficiency < 0.9){
                    count.warning = 1;
                }else{
                    count.warning = 0;
                }

                lastEntry = count;
                return count;
            }).reverse();

        },

        timespans: function(){

            var _timespans = [];

            if(this.productionCounts.length > 1){

                var timespan = undefined;

                var reverseLogs = [...this.productionCounts].reverse();

                console.log("reversed logs", reverseLogs);



                reverseLogs.forEach((log, index) => {

                    console.log("Log", index);

                    let logType = log.code?log.code:"production";




                    if(!timespan){

                        console.log("Starting new timespan", logType, index);
                        timespan = {
                            start: new Date(log.date),
                            end: null,
                            duration: 0,
                            logs: [log],
                            production: 0,
                            targetProduction: 0,
                            type: logType
                        }

                        if(_timespans.length){
                            //handle case where a filler count is added in between non-production count logs
                            //do we need to create an implicit production timespan to fill in a gap between two explicit timespans?

                            let lastTimespan = _timespans[_timespans.length - 1];
                            if(log.detail == "start"){ //we need to create a gap timespan between this and last one
                                console.log("Generating gap production timespan before", logType, index);
                                let logDate = new Date(log.date);
                                let gapTimespan = {
                                    start: lastTimespan.end,
                                    end: logDate,
                                    duration: (logDate.getTime() - lastTimespan.end.getTime())/60000,
                                    logs: [lastTimespan.logs[lastTimespan.logs.length - 1], log],
                                    production: parseInt(log.value) - parseInt(lastTimespan.logs[lastTimespan.logs.length - 1].value),
                                    targetProduction: ((logDate.getTime() - lastTimespan.end.getTime())/60000) * this.expectedPPM,
                                    type: "production"
                                }

                                _timespans.push(gapTimespan);

                            }else { //we need to change start time of new timespan to end of last timespan and leave open

                                console.log("Backfilling new log start time", lastTimespan, index);

                                timespan.end = timespan.start;
                                timespan.start = lastTimespan.end;
                                timespan.logs.unshift(lastTimespan.logs[lastTimespan.logs.length - 1]);
                                timespan.duration = (timespan.end.getTime() - timespan.start.getTime())/60000;
                                timespan.production = parseInt(timespan.logs[timespan.logs.length - 1].value) - parseInt(timespan.logs[0].value);
                                timespan.targetProduction = (timespan.type == "production")?(this.expectedPPM * timespan.duration):0;
                                console.log("Backfill complete", timespan, index);

                                if(timespan.type == "production"){
                                    _timespans.push(timespan);
                                    timespan = undefined;
                                }

                            }

                        }


                    }else{

                        console.log("Continuing existing timespan", logType, index);

                        timespan.logs.push(log);
                        timespan.end = new Date(log.date);
                        timespan.duration = (timespan.end.getTime() - timespan.start.getTime())/60000;
                        timespan.production = parseInt(timespan.logs[timespan.logs.length - 1].value) - parseInt(timespan.logs[0].value);
                        timespan.targetProduction = (timespan.type == "production")?(this.expectedPPM * timespan.duration):0;

                        //check if this is the end of current timespan
                        if(logType == "production") {
                            //always close out each production span into it's own chunk
                            console.log("closing current timespan, and leaving things undefined", logType, index);
                            _timespans.push(timespan);
                            timespan = undefined;


                        } else if(logType != timespan.type){
                            //this is probably a "start" log of some type
                            console.log("closing current timespan, and starting new one", logType, index);
                            _timespans.push(timespan);
                            timespan = {
                                start: new Date(log.date),
                                end: null,
                                duration: 0,
                                logs: [log],
                                production: 0,
                                targetProduction: 0,
                                type: logType
                            }

                        }else{
                            if(log.detail == "end"){
                                //this should end the the current timespan
                                console.log("closing current timespan, and leaving things undefined", logType, index);
                                _timespans.push(timespan);
                                timespan = undefined;
                            }
                        }
                    }
                })

                console.log("timespans", _timespans);


            }

            return _timespans;
        },


        productionLogs: function(){
            if(!this.sortedLogs) { return [] }
            return this.sortedLogs.filter((entry) => {
                return ((entry.tag != "downtime") && (entry.tag != "loss"));
            })
        },




        downtimeLogs: function(){
            if(!this.sortedLogs) { return [] }
            return this.sortedLogs.filter((entry) => {
                return (entry.tag == "downtime")
            })

        },

        downtimeMinutes: function(){
            return this.downtimeLogs.reduce((total, log) => {
                total += log.value;
                return total;
            }, 0)
        },

        externalDowntimeMinutes: function(){
            return this.downtimeLogs.reduce((total, log) => {
                if(log.code.toLowerCase() === "external"){
                    total += log.value;
                }
                return total;
            }, 0)
        },

        internalDowntimeMinutes: function(){
            return this.downtimeLogs.reduce((total, log) => {
                if(log.code.toLowerCase() !== "external"){
                    total += log.value;
                }
                return total;
            }, 0)
        },

        lossLogs: function(){
            if(!this.sortedLogs) { return [] }
            return this.sortedLogs.filter((entry) => {
                return (entry.tag == "loss")
            })

        },

        lossAmount: function(){
            return this.lossLogs.reduce((total, log) => {
                total += log.value;
                return total;
            }, 0)
        },

        logButtonLabel: function(){

            var label = "Log Entry";

            switch (this.logFilter) {
                case 'downtime':
                    label =  "Downtime Incident";
                    break;

                case 'loss':
                    label =  "Loss Amount";
                    break;

                default:
                    break;
            }

            return label;
        },



        firstproductionCount: function(){
            if(this.productionCounts.length){
                return this.productionCounts[this.productionCounts.length - 1];
            }

            return null
        },

        firstProductionTimespan: function(){
            if(this.timespans && this.timespans.length){
                let firstProduction = this.timespans.find((timespan) => {
                    return timespan.type == "production"
                });

                return firstProduction;
            }

            return null
        },

        lastproductionCount: function(){
            if(this.productionCounts.length){
                return this.productionCounts[0];
            }

            return null
        },

        countChartOptions: function() {

            var time = {
                unit: "hour"
            }

            if(!this.firstproductionCount){
                time.min = this.expectedStartDate,
                time.max = this.expectedCompletionDate
            }

            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                      type: 'time',
                      time: time
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            suggestedMax: this.order?this.order.amount_ordered:1000
                        }
                        

                    }]
              }
            }
        },

        shortcutOptions: function(){

            var options = [];

            if(this.logStarted){ //keep in mind that productionStarted just means that the setup has begun

                if(this.logFilter == "downtime"){
                    options.push("downtime");
                    return options;
                }

                if(this.logFilter == "loss"){
                    options.push("loss");
                    return options;
                }


                if(this.productionPaused){

                    if(this.lineState == "setup"){
                        options.push("setup:end");
                        return options;
                    }

                    if(this.lineState == "cleaning"){
                        options.push("cleaning:end");
                        return options;
                    }

                    if(this.lineState == "lunch"){
                        options.push("lunch:end");
                        return options;
                    }


                    if(this.lineState == "pause"){

                        options.push("pause:end");
                        return options;

                    }

                }

                // if(!this.setup.end){
                //     options.push("setup:end");
                //     return options;
                // }
                //
                // if(this.cleaning.start && !this.cleaning.end){
                //     options.push("cleaning:end");
                //     return options;
                // }
                //
                // if(this.cleaning.start && this.cleaning.end){
                //     options.push("downtime");
                //     return options;
                // }
                //
                //
                //
                // if(this.lunch.start){
                //     if(!this.lunch.end){
                //         options.push("lunch:end");
                //         return options;
                //     }
                // }else{
                //     options.push("lunch:start");
                // }




                options.push("lunch:start");
                options.push("cleaning:start");
                options.push("downtime");
                options.push("pause:start");
                options.push("loss");
                options.push("count:"+this.order.product.counter);
                //options.push("count:packer");
                //options.push("note");

            }else{
                options.push("setup:start");
            }



            return options;
        }
    }


}
</script>

<style>



    .tab[data-active="true"]{
        @apply bg-gray-300 text-black;
    }

    .log-button[data-mode="downtime"]{
        @apply bg-red-500;
    }

    .log-button[data-mode="loss"]{
        @apply bg-red-500;
    }

    .work-order[data-closed="true"] .edit-btn {
        pointer-events: none;

    }

    .work-order[data-closed="true"] .edit-btn span {
        display: none;

    }

    tr[data-warning="3"] td {
        background-color: red;
        color: white;

    }

    tr[data-warning="2"] td {
        background-color: rgba(255,255,0, 0.2);

    }

    tr[data-warning="1"] td {
        background-color: rgba(0,255,255, 0.1);

    }


    tr[data-error="true"] td {
        background-color: red;
        color: white;

    }

    tr:hover td {
        @apply bg-teal-200 text-black;

    }






</style>